import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import {
  GetNotificationById,
  GetUserNotifications,
} from "../manageComplaints/data";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";

const Notification = () => {
  const { userId } = useAuthData();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [viewNotificationData, setViewNotificationData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [notificationView,setNotificationView] = useState(false)

  const itemsPerPage = 5;

  useEffect(() => {
    fetchNotificationData();
  }, []);

  const startIndex = currentPage * itemsPerPage;
  const currentLogs = notifications.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  //pagination function
  const handlePageChange = (direction) => {
    if (
      direction === "older" &&
      startIndex + itemsPerPage < notifications.length
    ) {
      setCurrentPage((prev) => prev + 1);
    }
    if (direction === "newer" && currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  //fetch api call
  const fetchNotificationData = async () => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, GetUserNotifications, {
        userId: userId,
      });
      const allNotifications = res?.getNotificationByUserid?.data || [];
      // Sort unread notifications to the top
      const sortedNotifications = allNotifications.sort((a, b) =>
        a.status === "unread" && b.status !== "unread" ? -1 : 1
      );
      setNotifications(sortedNotifications);
    } catch (error) {
      setNotifications([]);
    } finally {
      setIsLoading(false);
    }
  };

  //view api call
  const viewNotification = async (id) => {
    try {
      const res = await request(BASEURL, GetNotificationById, { id });
      const notificationData = res?.getNotificationById?.data[0] || null;
      setViewNotificationData(notificationData);
      setDialogOpen(true);
      setNotificationView(true)
    } catch (error) {
      setViewNotificationData(null);
    }
  };

  

  return (
    <DashboardLayout notificationView={notificationView}>
      <Box sx={{ padding: 2, margin: "0 auto" }}>
        {isLoading ? (
          <Typography variant="h6" textAlign="center">
            Loading...
          </Typography>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "10px 20px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                marginBottom: "20px",
                borderRadius: "15px",
              }}
            >
              <IconButton
                onClick={() => navigate(-1)}
                sx={{
                  mr: 2,
                  backgroundColor: "#a5d6a7",
                  borderRadius: "50%",
                  "&:hover": { backgroundColor: "#4caf50" },
                }}
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6" fontWeight={600}>
                Notifications
              </Typography>
            </Box>
            <Grid container direction="column" spacing={2}>
              {currentLogs.map((log) => (
                <Grid item key={log.id}>
                  <Card
                    sx={{
                      borderLeft:
                        log.status === "unread"
                          ? "5px solid #4caf50"
                          : "5px solid #a5d6a7",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      boxShadow: "none",
                      height: "80px",
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontWeight={600} noWrap>
                          {log.message}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {log.module}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          textAlign: "right",
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Box>
                          <Typography sx={{ fontSize: "14px", mb: -1 }}>
                            {new Date(log.createdAt).toLocaleDateString()}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {new Date(log.createdAt).toLocaleTimeString()}
                          </Typography>
                        </Box>
                        {log.status === "unread" ? (
                          <VisibilityIcon
                            onClick={() => viewNotification(log.id)}
                            sx={{ color: "#4caf50", cursor: "pointer" }}
                          />
                        ) : (
                          <CheckCircleIcon sx={{ color: "#4caf50" }} />
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 2,
              }}
            >
              <MaterialButton
                sx={{ borderRadius: "20px" }}
                variant="gradient"
                color="dark"
                disabled={currentPage === 0}
                onClick={() => handlePageChange("newer")}
              >
                Newer
              </MaterialButton>
              <MaterialButton
                sx={{ borderRadius: "20px" }}
                variant="gradient"
                color="dark"
                disabled={startIndex + itemsPerPage >= notifications.length}
                onClick={() => handlePageChange("older")}
              >
                Older
              </MaterialButton>
            </Box>
          </>
        )}
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <b>Notification Details</b>
          </DialogTitle>
          <DialogContent>
            {viewNotificationData ? (
              <>
                <Typography variant="body2">
                  <strong>Module:</strong> {viewNotificationData.module}
                </Typography>
                <Typography variant="body2">
                  <strong>Message:</strong> {viewNotificationData.message}
                </Typography>
                <Typography variant="body2">
                  <strong>Status:</strong> {viewNotificationData.status}
                </Typography>
                <Typography variant="body2">
                  <strong>Date:</strong>{" "}
                  {new Date(viewNotificationData.createdAt).toLocaleString()}
                </Typography>
              </>
            ) : (
              <Typography variant="body1" color="error">
                Unable to fetch details.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <MaterialButton
              variant="gradient"
              color="dark"
              sx={{ borderRadius: "20px" }}
              onClick={() => {
                setDialogOpen(false);
                fetchNotificationData();
              }}
            >
              Close
            </MaterialButton>
          </DialogActions>
        </Dialog>
      </Box>
    </DashboardLayout>
  );
};

export default Notification;
